export default "__VITE_PUBLIC_ASSET__fd777637__"